import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { AirplanemodeActive, SignalCellular0BarRounded, SignalCellular1BarRounded, SignalCellular2BarRounded, SignalCellular3BarRounded, SignalCellular4BarRounded, SignalCellularOffRounded, } from '@mui/icons-material';
export const IconElement = memo(forwardRef((props, ref) => {
    const { icon_type, ...rest } = props;
    switch (icon_type) {
        case 'gsm-radiosilence':
            return _jsx(ResponsiveIcon, { Icon: AirplanemodeActive, ...rest, ref: ref });
        case 'gsm-no':
            return (_jsx(ResponsiveIcon, { Icon: SignalCellularOffRounded, ...rest, ref: ref }));
        case 'gsm-0':
            return (_jsx(ResponsiveIcon, { Icon: SignalCellular0BarRounded, ...rest, ref: ref }));
        case 'gsm-1':
            return (_jsx(ResponsiveIcon, { Icon: SignalCellular1BarRounded, ...rest, ref: ref }));
        case 'gsm-2':
            return (_jsx(ResponsiveIcon, { Icon: SignalCellular2BarRounded, ...rest, ref: ref }));
        case 'gsm-3':
            return (_jsx(ResponsiveIcon, { Icon: SignalCellular3BarRounded, ...rest, ref: ref }));
        default:
            return (_jsx(ResponsiveIcon, { Icon: SignalCellular4BarRounded, ...rest, ref: ref }));
    }
}));
IconElement.displayName = 'GSMIconElement';
